<!-- title -->
<app-modal-title
  [isShowClose]="true"
  (isCloseModal)="onClose()"
></app-modal-title>

<div class="tw-grid tw-grid-cols-3 tw-gap-3 dark:!tw-bg-dark-500 tw-p-7">
  <div *ngFor="let year of years">
    <div
      class="tw-text-center tw-py-2 tw-rounded-full tw-text-base tw-font-bold tw-text-gray-700 dark:tw-text-gray-300"
      (click)="onSelectYear(year)"
      [class]="
        year > 1404
          ? 'tw-cursor-not-allowed tw-opacity-50'
          : 'tw-cursor-pointer'
      "
      [ngClass]="activeYear(year)"
    >
      {{ year }}
    </div>
  </div>
</div>
